import { render, staticRenderFns } from "./ResumoAluno.vue?vue&type=template&id=3d9ab447&"
import script from "./ResumoAluno.vue?vue&type=script&lang=js&"
export * from "./ResumoAluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports